export default import.meta.ROLLDOWN_FILE_URL_DeXfLzj6pWgslXT5yi_ZZw